export default "__VITE_ASSET__DXKZndvE__"